import axios from "axios";
import { url, AuthHeader } from "../../utils/_exports";
import { useQuery } from "@tanstack/react-query";
const apiURL = "my_tasks";

export function getMyTasksListQuery(_filter: any = {}) {
	return useQuery({
		queryKey: ["my_tasks"],
		queryFn: () =>
			axios
				.get(`${url}/${apiURL}`, {
					params: { filter: JSON.stringify(_filter) },
					...AuthHeader,
				})
				.then((res) => {
					// add field name called task_title which combines the name and task_number fields
					return res.data.map((item: any) => ({
						...item,
						task_title: `${item.name} - ${item.task_number}`,
					}));
				})
				.catch((e: any) => {
					console.log("Fail to get my tasks list", e);
					return [];
				}),
		staleTime: 5 * 60 * 1000,
	});
}

export async function getMyTasks(filter = {}): Promise<any[]> {
	try {
		const response = await axios.get(`${url}/${apiURL}`, {
			params: { filter: JSON.stringify(filter) },
			...AuthHeader,
		});
		return response.data;
	} catch (error: any) {
		console.log("Fail to get my tasks list", error);
		return [];
	}
}

export const addMyTasksItem = (data: any) => {
	return new Promise((resolve, reject) => {
		axios
			.post(`${url}/${apiURL}`, data, AuthHeader)
			.then((_data: any) => {
				resolve(_data.data);
			})
			.catch((e: any) => {
				console.log("error", e);
				reject(e);
			});
	});
};

export const updateMyTasksItem = (filter: {}, data: {}) => {
	return new Promise((resolve, reject) => {
		axios
			.put(
				`${url}/${apiURL}`,
				{
					filter: filter,
					data: data,
					options: { upsert: true, new: true },
				},
				AuthHeader
			)
			.then((_data: any) => {
				resolve(_data.data[0]);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};

export const deleteMyTasksItem = (uuid: any) => {
	return new Promise((resolve, reject) => {
		axios
			.delete(`${url}/${apiURL}`, {
				params: {
					filter: JSON.stringify({ _id: uuid }),
				},
				...AuthHeader,
			})
			.then((_data) => {
				resolve(true);
			})
			.catch((e: any) => {
				reject(e);
			});
	});
};
